/* RESPONSIBLE TEAM: team-omni */
import Service from '@ember/service';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type Store from '@ember-data/store';
import type Session from 'embercom/services/session';
import type SlackIntegrationModel from 'embercom/models/slack/integration';

export default class SlackIntegrationService extends Service {
  @service declare store: Store;
  @service declare session: Session;

  @tracked slackIntegration: SlackIntegrationModel | null = null;

  async loadIntegration(): Promise<void> {
    if (!this.session.workspace.isFeatureEnabled('team-omni-slack')) {
      return;
    }

    try {
      this.slackIntegration = await this.store.queryRecord('slack/integration', {
        app_id: this.session.workspace.id,
      });
    } catch (error) {
      console.error('Error loading Slack integration:', error);
      this.slackIntegration = null;
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    'slack-integration-service': SlackIntegrationService;
  }
}
